import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../auth.service';
import { SchoolHealthModel, SchoolHealthFilter } from '../../models/school/school-health.model';
import { GroupActivitySummary } from '../../models/school/group.model';
import { StringExtensionModel } from '../../models/extensions/string-extension.model';

@Injectable({
  providedIn: 'root'
})
export class AdminSchoolHealthService {

  constructor(private authSv: AuthService) {}

  getSchoolHealthList(filters?: SchoolHealthFilter): Observable<SchoolHealthModel[]> {
    let url = '/admin/schoolHealth';
    if (filters) {
      url += StringExtensionModel.queryString(filters);
    }
    return this.authSv.get(url).pipe(map(res => SchoolHealthModel.generateList(res.data)));
  }

  getSchoolHealth(schoolId: string): Observable<SchoolHealthModel> {
    return this.authSv.get(`/admin/schoolHealth/${schoolId}`).pipe(
      map(res => SchoolHealthModel.generate(res.data))
    );
  }

  getSchoolHealthById(schoolHealthId: string): Observable<SchoolHealthModel> {
    return this.authSv.get(`/admin/schoolHealth/record/${schoolHealthId}`).pipe(
      map(res => SchoolHealthModel.generate(res.data))
    );
  }

  refreshSchoolHealth(schoolId: string, schoolHealthId: string): Observable<SchoolHealthModel> {
    return this.authSv.post(`/admin/schoolHealth/${schoolId}/refresh/${schoolHealthId}`, {}).pipe(
      map(res => SchoolHealthModel.generate(res.data))
    );
  }

  backfillSchoolHealth(schoolId: string, schoolHealthId: string): Observable<SchoolHealthModel> {
    return this.authSv.post(`/admin/schoolHealth/${schoolId}/backfill/${schoolHealthId}`, {}).pipe(
      map(res => SchoolHealthModel.generate(res.data))
    );
  }

  getGroupsActivitySummary(schoolId: string, schoolYearId: string): Observable<GroupActivitySummary[]> {
    return this.authSv.get(`/admin/schoolHealth/${schoolId}/groups?schoolYearId=${schoolYearId}`).pipe(
      map(res => res.data as GroupActivitySummary[])
    );
  }

  syncLicense(schoolHealthId: string, data: { numLicenses: number }): Observable<SchoolHealthModel> {
    return this.authSv.patch(`/admin/schoolHealth/${schoolHealthId}/syncLicense`, data).pipe(
      map(res => SchoolHealthModel.generate(res.data))
    );
  }

  updateCheckpoint(schoolHealthId: string, field: string, data: { date: string | null; declined: boolean; confirmed?: boolean; groupIds?: string[] }): Observable<SchoolHealthModel> {
    return this.authSv.patch(`/admin/schoolHealth/${schoolHealthId}/checkpoints/${field}`, data).pipe(
      map(res => SchoolHealthModel.generate(res.data))
    );
  }

  addCheckpointNote(schoolHealthId: string, field: string, text: string): Observable<SchoolHealthModel> {
    return this.authSv.post(`/admin/schoolHealth/${schoolHealthId}/checkpoints/${field}/notes`, { text }).pipe(
      map(res => SchoolHealthModel.generate(res.data))
    );
  }

  resolveAllMigrationFlags(schoolHealthId: string): Observable<SchoolHealthModel> {
    return this.authSv.post(`/admin/schoolHealth/${schoolHealthId}/resolveAllFlags`, {}).pipe(
      map(res => SchoolHealthModel.generate(res.data))
    );
  }
}
